import React, { FC } from 'react';

interface ImgWebp {
  webpSrc?: string;
  fallback: string;
  alt: string;
  className?: string;
}

const defaultProps = {
  webpSrc: '',
  className: '',
};

export const ImgWebp: FC<ImgWebp> = ({ webpSrc, fallback, alt, className }) => {
  return (
    <picture className={className}>
      <source srcSet={webpSrc} type="image/webp" />
      <img src={fallback} alt={alt} />
    </picture>
  );
};

ImgWebp.defaultProps = defaultProps;
